import * as React from "react";
import {
  Box,
  Container,
  List,
  ListItem,
  ListItemButton,
  Paper,
  Typography,
} from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../../common/seo";

const BEST_OF_PATH = "/best-of";

const bestOfPages = [
  {
    title: "Best Parks & Lakes in Northwest Arkansas",
    description:
      "Quick links to photo-worthy trails, parks, and fishing spots.",
    to: "/best-parks-lakes-northwest-arkansas",
  },
  {
    title: "Best Parks in Northwest Arkansas",
    description: "Quick links to park overviews.",
    to: "/best-parks-northwest-arkansas",
  },
  {
    title: "Best Trails in Northwest Arkansas",
    description: "Quick links to bike trails, walking trails, and greenways.",
    to: "/best-trails-northwest-arkansas",
  },
  {
    title: "Best Food in Northwest Arkansas",
    description: "Quick links to food posts and local favorites.",
    to: "/best-food-northwest-arkansas",
  },
];

export function BestOf() {
  const location = useLocation();
  const pathname = location.pathname || BEST_OF_PATH;

  const title = "Best Of Northwest Arkansas | NWA Blog";
  const description =
    "Browse curated 'Best Of' hubs for Northwest Arkansas—parks, lakes, trails, food, and more.";

  return (
    <Container component="section" sx={{ marginTop: "5rem" }}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl(pathname)} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl(pathname)} />
      </Helmet>

      <Paper elevation={1} sx={{ padding: "1rem", textAlign: "center" }}>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Best Of
        </Typography>
        <Typography variant="body2" sx={{ marginTop: ".5rem" }}>
          Curated hubs with quick links to the best spots.
        </Typography>
      </Paper>

      <Box sx={{ marginTop: "1rem" }}>
        <List>
          {bestOfPages.map((page) => (
            <ListItem
              key={page.to}
              disablePadding
              sx={{ marginBottom: ".75rem" }}
            >
              <ListItemButton
                component={RouterLink}
                to={page.to}
                sx={{ padding: 0, borderRadius: 3 }}
              >
                <Paper
                  elevation={2}
                  sx={{
                    width: "100%",
                    border: "2px solid",
                    borderColor: "accent.main",
                    borderRadius: 3,
                    overflow: "hidden",
                  }}
                >
                  <Box sx={{ bgcolor: "accent.main", height: ".25rem" }} />
                  <Box sx={{ bgcolor: "secondary.main", height: ".5rem" }} />
                  <Box sx={{ padding: ".75rem" }}>
                    <Typography variant="h6" sx={{ color: "accent.main" }}>
                      {page.title}
                    </Typography>
                    <Typography variant="body2">{page.description}</Typography>
                  </Box>
                </Paper>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Container>
  );
}
